export enum BusinessUnit {
  LOVE = 'love',
  SELF_DISCOVERY = 'self-discovery',
  RND = 'rnd',
  OTHER = 'other',
}
